import { Fragment, useEffect, useState } from "react";
import { formatCurrency } from "src/utils/FormatCurrency";
import { AmountTotalType } from "src/models/AmountTotalType";
import { MerchantTransactionSummaryModel } from "src/models/MerchantTransactionSummaryModel";

type MerchantTransactionDetailSummaryDataProps = {
  summaryDetail: MerchantTransactionSummaryModel;
};

const MerchantTransactionDetailSummaryData = ({
  summaryDetail,
}: MerchantTransactionDetailSummaryDataProps) => {
  const [summaryData, setSummaryData] =
    useState<MerchantTransactionSummaryModel>(
      {} as MerchantTransactionSummaryModel
    );

  useEffect(() => {
    if (summaryDetail) {
      setSummaryData(summaryDetail);
    }
  }, [summaryDetail]);

  return (
    <div className="">
      <div className="row">
        <div className="col-6 summary-data">
          {summaryData?.amountTypes?.map((t: AmountTotalType, idx: number) => (
            <Fragment key={`amountTotals-${idx}`}>
              <div className="grouping1">
                <div>Total Amount</div>
                <div>
                  {formatCurrency(t.totalCardAmount, t.currencyAlphaCode)}
                </div>
              </div>
            </Fragment>
          ))}
        </div>
        <div className="col-6 summary-data">
          <div className="grouping">
            <div>Total Transactions</div>
            <div>{summaryData?.totalTransactionCount}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantTransactionDetailSummaryData;
